
import { ImageBackdropLayers, cn } from '@/components/help-center/latest-power-shared';

export default function PowerDarkCardShell({
  children,
  className,
  innerClassName,
}: {
  children: React.ReactNode;
  className?: string;
  innerClassName?: string;
}) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-2xl border border-blue-900/60',
        'bg-blue-950/30 shadow-lg shadow-black/25 ring-1 ring-sky-500/15',
        className
      )}
    >
      <ImageBackdropLayers className="absolute inset-0 overflow-hidden rounded-2xl" />
      <div className="pointer-events-none absolute inset-0 bg-[#030023]/55" aria-hidden />
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#000b6a]/35 via-[#030023]/20 to-[#030023]/75"
        aria-hidden
      />
      <div className={cn('relative z-10', innerClassName)}>{children}</div>
    </div>
  );
}
